import React, { useState } from "react";
import {
  makeStyles,
  useMediaQuery,
  useTheme,
  Popover,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import TimelinePopUp from "./TimelinePopUp";
import { ATLTinkerpreneurTimelineBox } from "./index";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(1),
      width: "100%",
    },
  },
  timelineItem: {
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      justifyContent: "flex-start",
    },
  },
  separator: {
    minWidth: "16px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "16px",
    },
  },
  timelineDot: {
    width: 16,
    height: 16,
    marginTop: 4,
  },
  completedConnector: {
    backgroundColor: theme.palette.primary.main,
    marginTop: 0,
    marginBottom: 0,
  },
  timelineContent: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
}));

const ATLTinkerpreneurTimeline = ({ events, handleEnroll }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  const handleCardClick = (event, timelineEvent) => {
    if (timelineEvent.status === "Pending") return;
    setAnchorEl(event.currentTarget);
    setSelectedEvent(timelineEvent);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedEvent(null);
  };

  const open = Boolean(anchorEl);

  const getDotColor = (event) => {
    switch (event.status) {
      case "Upcoming":
        return "secondary";
      case "Pending":
        return "inherit";
      default:
        return "primary";
    }
  };

  const newToAiEvents = events.filter((e) => e.category === "newToAI");
  const intermediateToAIEvents = events.filter(
    (e) => e.category === "intermediateAI"
  );
  const itFacultyEvents = events.filter((e) => e.category === "itFaculty");

  return (
    <div className={classes.container}>
      <h2 className="mar-b-30 text-center">
        {t("atl_tinkerpreneur.timeline_heading_text")}
      </h2>

      {newToAiEvents.length > 0 && (
        <>
          <ATLTinkerpreneurTimelineBox
            events={newToAiEvents}
            isMobile={isMobile}
            getDotColor={getDotColor}
            category={"newToAI"}
            classes={classes}
            onCardClick={(e, item) => handleCardClick(e, item)}
          />
        </>
      )}

      {intermediateToAIEvents.length > 0 && (
        <>
          <ATLTinkerpreneurTimelineBox
            events={intermediateToAIEvents}
            isMobile={isMobile}
            getDotColor={getDotColor}
            category={"intermediateAI"}
            classes={classes}
            onCardClick={(e, item) => handleCardClick(e, item)}
          />
        </>
      )}

      {itFacultyEvents.length > 0 && (
        <>
          <ATLTinkerpreneurTimelineBox
            events={itFacultyEvents}
            isMobile={isMobile}
            getDotColor={getDotColor}
            category={"itFaculty"}
            classes={classes}
            onCardClick={(e, item) => handleCardClick(e, item)}
          />
        </>
      )}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {selectedEvent && (
          <TimelinePopUp
            event={selectedEvent}
            onClose={handleClose}
            handleEnroll={handleEnroll}
          />
        )}
      </Popover>
    </div>
  );
};

export default ATLTinkerpreneurTimeline;
